import { FunctionComponent, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TabItem, Tabs, useIsNarrowViewport } from '../../../../shared';
import { CardTemplates } from '../CardTemplates';
import { Category } from '../Category';

import classes from './Templates.module.scss';

enum TemplatesTabType {
  CATEGORIES,
  CARDS,
}

export const Templates: FunctionComponent = () => {
  const { t } = useTranslation();

  const isNarrowViewport = useIsNarrowViewport();

  const [selectedTabIndex, setSelectedTabIndex] = useState(TemplatesTabType.CATEGORIES);

  const tabItems: TabItem[] = useMemo(
    () => [
      {
        index: TemplatesTabType.CATEGORIES,
        name: t('storyCardCategory.title'),
        content: <Category />,
      },
      {
        index: TemplatesTabType.CARDS,
        name: t('storyCardTemplates.cards'),
        content: <CardTemplates />,
      },
    ],
    [t]
  );

  return (
    <Tabs
      className={classes['templates']}
      items={tabItems}
      selectedTabIndex={selectedTabIndex}
      setSelectedTabIndex={setSelectedTabIndex}
      scrollable={isNarrowViewport}
      noBackground
    />
  );
};
